<button mat-icon-button [disabled]="zoningCode.isDeleting || zoningCode.isOrphan"
    [class.not-clickable-actions-buttons]="zoningCode.isDeleting" class="actions-buttons">
    <mat-icon
        matTooltip="Index Zoning Code Process.
        Allows to create new Indexing task which will start indexation with offset equal to number of records in DB.
        Uses old indexing mechanism based on data offset. GAPI response time will increase with increasing of offset value. Recommended for small Zoning Codes."
        (click)="openIndexZCPropertyRecordsTaskDialog($event, zoningCode)" class="actions-mat-icons">
        get_app</mat-icon>
</button>
